import AccountResetPasswordController from "./controller";
import UserResetPasswordComponents from "./components/module";
const modul = angular
    .module("AccountResetPasswordModule", [UserResetPasswordComponents])

    .controller(
        "AccountResetPasswordController",
        AccountResetPasswordController
    );

export default modul.name;
